import { SOFT_FAIL_CAPTURE_TOOLS } from "./soft-fail-capture-tools-constants";
/**
 * Capture tools report failure as prose on a `completed` call, always opening
 * with their own name. Anchored there: a delivered `failed.txt` is a success.
 */
export function softFailedCapture(toolName: string, output: unknown): boolean {
  if (!SOFT_FAIL_CAPTURE_TOOLS.has(toolName) || typeof output !== "string") {
    return false;
  }
  return output.trimStart().startsWith(`${toolName} failed`);
}
